// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_context = require("./MM_context.res.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var MM_parenCounter = require("./MM_parenCounter.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");

function subsClone(subs) {
  return {
          size: subs.size,
          begins: subs.begins.slice(),
          ends: subs.ends.slice(),
          exprs: subs.exprs.slice(),
          isDefined: subs.isDefined.slice()
        };
}

function subsEq(a, b) {
  if (!(a.size === b.size && a.isDefined.every(function (b) {
            return b;
          }) && b.isDefined.every(function (b) {
            return b;
          }))) {
    return false;
  }
  var res = true;
  var v = 0;
  while(res && v < a.size) {
    var aExpr = a.exprs[v];
    var aBegin = a.begins[v];
    var aEnd = a.ends[v];
    var aExprLen = (aEnd - aBegin | 0) + 1 | 0;
    var bExpr = b.exprs[v];
    var bBegin = b.begins[v];
    var bEnd = b.ends[v];
    var bExprLen = (bEnd - bBegin | 0) + 1 | 0;
    if (aExprLen === bExprLen) {
      var ai = aBegin;
      var bi = bBegin;
      while(res && ai <= aEnd) {
        res = aExpr[ai] === bExpr[bi];
        ai = ai + 1 | 0;
        bi = bi + 1 | 0;
      };
    } else {
      res = false;
    }
    v = v + 1 | 0;
  };
  return res;
}

function subsHash(subs) {
  if (!subs.isDefined.every(function (b) {
          return b;
        })) {
    return 0;
  }
  var hash = 0;
  var v = 0;
  while(v < subs.size) {
    hash = Expln_utils_common.hash2(hash, Expln_utils_common.hashArrIntFromTo(subs.exprs[v], subs.begins[v], subs.ends[v]));
    v = v + 1 | 0;
  };
  return hash;
}

function lengthOfGap(leftConstPartIdx, constParts, exprLength) {
  if (leftConstPartIdx < 0) {
    return constParts[0][0];
  } else if (leftConstPartIdx < (constParts.length - 1 | 0)) {
    return (constParts[leftConstPartIdx + 1 | 0][0] - constParts[leftConstPartIdx][1] | 0) - 1 | 0;
  } else {
    return (exprLength - constParts[leftConstPartIdx][1] | 0) - 1 | 0;
  }
}

function lengthOfGap2(leftConstPartIdx, constParts, exprLength) {
  if (leftConstPartIdx < 0) {
    return constParts.begins[0];
  } else if (leftConstPartIdx < (constParts.length - 1 | 0)) {
    return (constParts.begins[leftConstPartIdx + 1 | 0] - constParts.ends[leftConstPartIdx] | 0) - 1 | 0;
  } else {
    return (exprLength - constParts.ends[leftConstPartIdx] | 0) - 1 | 0;
  }
}

function createConstParts(expr) {
  var constParts = [];
  for(var i = 0 ,i_finish = expr.length; i < i_finish; ++i){
    var constPartsLength = constParts.length;
    if (expr[i] < 0) {
      if (constPartsLength === 0 || constParts[constPartsLength - 1 | 0][1] >= 0) {
        constParts.push([
              i,
              -1
            ]);
      }
      
    } else if (constPartsLength > 0 && constParts[constPartsLength - 1 | 0][1] < 0) {
      constParts[constPartsLength - 1 | 0][1] = i - 1 | 0;
    }
    
  }
  var constPartsLength$1 = constParts.length;
  var exprLength = expr.length;
  if (constPartsLength$1 > 0 && constParts[constPartsLength$1 - 1 | 0][1] < 0) {
    constParts[constPartsLength$1 - 1 | 0][1] = exprLength - 1 | 0;
  }
  var result_begins = new Array(constPartsLength$1);
  var result_ends = new Array(constPartsLength$1);
  var result_remainingMinLength = new Array(constPartsLength$1);
  var result = {
    length: constPartsLength$1,
    begins: result_begins,
    ends: result_ends,
    remainingMinLength: result_remainingMinLength
  };
  var remainingMinLength = 0;
  for(var i$1 = constPartsLength$1 - 1 | 0; i$1 >= 0; --i$1){
    result_begins[i$1] = constParts[i$1][0];
    result_ends[i$1] = constParts[i$1][1];
    remainingMinLength = (remainingMinLength + ((result_ends[i$1] - result_begins[i$1] | 0) + 1 | 0) | 0) + lengthOfGap(i$1, constParts, exprLength) | 0;
    result_remainingMinLength[i$1] = remainingMinLength;
  }
  return result;
}

function createMatchingConstParts(constParts) {
  return {
          length: constParts.length,
          begins: new Array(constParts.length),
          ends: new Array(constParts.length),
          remainingMinLength: []
        };
}

function iterateConstParts(frmExpr, expr, frmConstParts, constParts, idxToMatch, parenCnt, consumer) {
  var invokeNext = function () {
    return iterateConstParts(frmExpr, expr, frmConstParts, constParts, idxToMatch + 1 | 0, parenCnt, consumer);
  };
  var exprLen = expr.length;
  var frmExprLen = frmExpr.length;
  if (exprLen < frmExprLen) {
    return "Continue";
  }
  if (idxToMatch === frmConstParts.length) {
    if (frmConstParts.length <= 0) {
      if (MM_parenCounter.parenCntCanBeFirst(parenCnt, expr[0]) && MM_parenCounter.parenCntCanBeLast(parenCnt, expr[exprLen - 1 | 0])) {
        return consumer(constParts);
      } else {
        return "Continue";
      }
    }
    if (constParts.ends[idxToMatch - 1 | 0] === (exprLen - 1 | 0)) {
      return consumer(constParts);
    }
    if (frmConstParts.ends[idxToMatch - 1 | 0] === (frmExprLen - 1 | 0)) {
      return "Continue";
    }
    var frmRemainingGapLength = lengthOfGap2(idxToMatch - 1 | 0, frmConstParts, frmExprLen);
    var remainingGapLength = lengthOfGap2(idxToMatch - 1 | 0, constParts, exprLen);
    if (remainingGapLength < frmRemainingGapLength) {
      return "Continue";
    }
    if (!MM_parenCounter.parenCntCanBeFirst(parenCnt, expr[constParts.ends[idxToMatch - 1 | 0] + 1 | 0]) || !MM_parenCounter.parenCntCanBeLast(parenCnt, expr[exprLen - 1 | 0])) {
      return "Continue";
    }
    MM_parenCounter.parenCntReset(parenCnt);
    var pState = "Balanced";
    var i = constParts.ends[idxToMatch - 1 | 0] + 1 | 0;
    while(i < exprLen && pState !== "Failed") {
      pState = MM_parenCounter.parenCntPut(parenCnt, expr[i]);
      i = i + 1 | 0;
    };
    if (pState === "Balanced") {
      return consumer(constParts);
    } else {
      return "Continue";
    }
  }
  if (idxToMatch === 0 && frmConstParts.begins[0] === 0) {
    if ((exprLen - 1 | 0) < frmConstParts.ends[0]) {
      return "Continue";
    }
    var res;
    var maxI = frmConstParts.ends[0];
    var i$1 = 0;
    while(Belt_Option.isNone(res) && i$1 <= maxI) {
      if (frmExpr[i$1] !== expr[i$1]) {
        res = "Continue";
      }
      i$1 = i$1 + 1 | 0;
    };
    var instr = res;
    if (instr !== undefined) {
      return instr;
    } else if (maxI === (exprLen - 1 | 0) || MM_parenCounter.parenCntCanBeFirst(parenCnt, expr[maxI + 1 | 0])) {
      constParts.begins[0] = 0;
      constParts.ends[0] = maxI;
      return invokeNext();
    } else {
      return "Continue";
    }
  }
  var begin = idxToMatch === 0 ? 0 : constParts.ends[idxToMatch - 1 | 0] + 1 | 0;
  var maxBegin = exprLen - frmConstParts.remainingMinLength[idxToMatch] | 0;
  MM_parenCounter.parenCntReset(parenCnt);
  var pState$1 = "Balanced";
  var numOfVars = lengthOfGap2(idxToMatch - 1 | 0, frmConstParts, frmExprLen);
  for(var _for = 1; _for <= numOfVars; ++_for){
    pState$1 = MM_parenCounter.parenCntPut(parenCnt, expr[begin]);
    begin = begin + 1 | 0;
  }
  var partLen = (frmConstParts.ends[idxToMatch] - frmConstParts.begins[idxToMatch] | 0) + 1 | 0;
  var instr$1 = "Continue";
  while(begin <= maxBegin && pState$1 !== "Failed" && instr$1 === "Continue") {
    if (pState$1 === "Balanced") {
      var matchedLen = 0;
      var cmpRes = true;
      while(matchedLen < partLen && cmpRes) {
        cmpRes = frmExpr[frmConstParts.begins[idxToMatch] + matchedLen | 0] === expr[begin + matchedLen | 0];
        matchedLen = matchedLen + 1 | 0;
      };
      var end = (begin + partLen | 0) - 1 | 0;
      if (matchedLen === partLen && cmpRes && MM_parenCounter.parenCntCanBeLast(parenCnt, expr[begin - 1 | 0]) && (end === (exprLen - 1 | 0) || MM_parenCounter.parenCntCanBeFirst(parenCnt, expr[end + 1 | 0]))) {
        constParts.begins[idxToMatch] = begin;
        constParts.ends[idxToMatch] = end;
        instr$1 = invokeNext();
        MM_parenCounter.parenCntReset(parenCnt);
      }
      
    }
    pState$1 = MM_parenCounter.parenCntPut(parenCnt, expr[begin]);
    begin = begin + 1 | 0;
  };
  return instr$1;
}

function createVarGroups(frmExpr, frmConstParts) {
  var frmExprLen = frmExpr.length;
  if (frmConstParts.length === 0) {
    return [{
              leftConstPartIdx: -1,
              frmExpr: frmExpr,
              varsBeginIdx: 0,
              numOfVars: frmExprLen,
              exprBeginIdx: 0,
              exprEndIdx: 0
            }];
  }
  var res = [];
  if (frmConstParts.begins[0] !== 0) {
    res.push({
          leftConstPartIdx: -1,
          frmExpr: frmExpr,
          varsBeginIdx: 0,
          numOfVars: frmConstParts.begins[0],
          exprBeginIdx: 0,
          exprEndIdx: 0
        });
  }
  for(var i = 0 ,i_finish = frmConstParts.length - 2 | 0; i <= i_finish; ++i){
    res.push({
          leftConstPartIdx: i,
          frmExpr: frmExpr,
          varsBeginIdx: frmConstParts.ends[i] + 1 | 0,
          numOfVars: lengthOfGap2(i, frmConstParts, frmExprLen),
          exprBeginIdx: 0,
          exprEndIdx: 0
        });
  }
  var lastConstPartIdx = frmConstParts.length - 1 | 0;
  if (frmConstParts.ends[lastConstPartIdx] !== (frmExprLen - 1 | 0)) {
    res.push({
          leftConstPartIdx: lastConstPartIdx,
          frmExpr: frmExpr,
          varsBeginIdx: frmConstParts.ends[lastConstPartIdx] + 1 | 0,
          numOfVars: lengthOfGap2(lastConstPartIdx, frmConstParts, frmExprLen),
          exprBeginIdx: 0,
          exprEndIdx: 0
        });
  }
  return res;
}

function initVarGroups(varGroups, constParts, expr) {
  var exprLen = expr.length;
  if (constParts.length === 0) {
    varGroups[0].exprBeginIdx = 0;
    varGroups[0].exprEndIdx = exprLen - 1 | 0;
  } else {
    varGroups.forEach(function (grp) {
          if (grp.leftConstPartIdx === -1) {
            grp.exprBeginIdx = 0;
            grp.exprEndIdx = constParts.begins[0] - 1 | 0;
          } else if (grp.leftConstPartIdx === (constParts.length - 1 | 0)) {
            grp.exprBeginIdx = constParts.ends[grp.leftConstPartIdx] + 1 | 0;
            grp.exprEndIdx = exprLen - 1 | 0;
          } else {
            grp.exprBeginIdx = constParts.ends[grp.leftConstPartIdx] + 1 | 0;
            grp.exprEndIdx = constParts.begins[grp.leftConstPartIdx + 1 | 0] - 1 | 0;
          }
        });
    Expln_utils_common.sortInPlaceWith(varGroups, (function (g1, g2) {
            return g1.numOfVars - g2.numOfVars | 0;
          }));
  }
}

function iterateVarGroups(expr, subs, varGroups, curGrpIdx, curVarIdx, subExprBeginIdx, parenCnt, consumer) {
  var grp = varGroups[curGrpIdx];
  var frmVar = grp.frmExpr[grp.varsBeginIdx + curVarIdx | 0];
  var maxSubExprLength = ((grp.exprEndIdx - subExprBeginIdx | 0) + 1 | 0) - ((grp.numOfVars - curVarIdx | 0) - 1 | 0) | 0;
  var invokeNext = function (subExprLength) {
    if (curVarIdx < (grp.numOfVars - 1 | 0)) {
      return iterateVarGroups(expr, subs, varGroups, curGrpIdx, curVarIdx + 1 | 0, subExprBeginIdx + subExprLength | 0, parenCnt, consumer);
    } else if (curGrpIdx < (varGroups.length - 1 | 0)) {
      return iterateVarGroups(expr, subs, varGroups, curGrpIdx + 1 | 0, 0, varGroups[curGrpIdx + 1 | 0].exprBeginIdx, parenCnt, consumer);
    } else {
      return consumer(subs);
    }
  };
  var continueInstr = "Continue";
  if (subs.isDefined[frmVar]) {
    var existingExpr = subs.exprs[frmVar];
    var existingExprBeginIdx = subs.begins[frmVar];
    var existingExprLen = (subs.ends[frmVar] - existingExprBeginIdx | 0) + 1 | 0;
    if (existingExprLen <= maxSubExprLength && (curVarIdx < (grp.numOfVars - 1 | 0) || existingExprLen === maxSubExprLength)) {
      var checkedLen = 0;
      while(checkedLen < existingExprLen && existingExpr[existingExprBeginIdx + checkedLen | 0] === expr[subExprBeginIdx + checkedLen | 0]) {
        checkedLen = checkedLen + 1 | 0;
      };
      if (checkedLen === existingExprLen) {
        continueInstr = invokeNext(existingExprLen);
      }
      
    }
    
  } else {
    subs.isDefined[frmVar] = true;
    subs.exprs[frmVar] = expr;
    subs.begins[frmVar] = subExprBeginIdx;
    if (curVarIdx === (grp.numOfVars - 1 | 0)) {
      subs.ends[frmVar] = grp.exprEndIdx;
      continueInstr = invokeNext(maxSubExprLength);
    } else if (MM_parenCounter.parenCntCanBeFirst(parenCnt, expr[subExprBeginIdx])) {
      var subExprLength = 1;
      var end = subExprBeginIdx;
      MM_parenCounter.parenCntReset(parenCnt);
      var pStatus = "Balanced";
      while(subExprLength <= maxSubExprLength && continueInstr === "Continue" && pStatus !== "Failed") {
        subs.ends[frmVar] = end;
        pStatus = MM_parenCounter.parenCntPut(parenCnt, expr[end]);
        if (pStatus === "Balanced" && MM_parenCounter.parenCntCanBeLast(parenCnt, expr[end])) {
          continueInstr = invokeNext(subExprLength);
          MM_parenCounter.parenCntReset(parenCnt);
        }
        subExprLength = subExprLength + 1 | 0;
        end = end + 1 | 0;
      };
    }
    subs.isDefined[frmVar] = false;
  }
  return continueInstr;
}

function iterateSubstitutions(frmExpr, expr, frmConstParts, constParts, varGroups, subs, parenCnt, consumer) {
  if (subs.size === 0) {
    if (MM_context.exprEq(frmExpr, expr)) {
      return consumer(subs);
    } else {
      return "Continue";
    }
  }
  var exprLen = expr.length;
  var frmExprLen = frmExpr.length;
  if (exprLen < frmExprLen || exprLen === 0 || frmExprLen === 0) {
    return "Continue";
  }
  var frmExprEnd = frmExpr[frmExprLen - 1 | 0];
  if (frmExprEnd < 0 && frmExprEnd !== expr[exprLen - 1 | 0]) {
    return "Continue";
  }
  var frmExprBegin = frmExpr[0];
  if (frmExprBegin < 0 && frmExprBegin !== expr[0]) {
    return "Continue";
  } else {
    return iterateConstParts(frmExpr, expr, frmConstParts, constParts, 0, parenCnt, (function (constParts) {
                  if (varGroups.length > 0) {
                    initVarGroups(varGroups, constParts, expr);
                    return iterateVarGroups(expr, subs, varGroups, 0, 0, varGroups[0].exprBeginIdx, parenCnt, consumer);
                  } else {
                    return consumer(subs);
                  }
                }));
  }
}

function createSubs(numOfVars) {
  return {
          size: numOfVars,
          begins: Belt_Array.make(numOfVars, 0),
          ends: Belt_Array.make(numOfVars, 0),
          exprs: Belt_Array.make(numOfVars, []),
          isDefined: Belt_Array.make(numOfVars, false)
        };
}

function prepareFrmSubsDataForFrame(frame) {
  var hypsE = frame.hyps.filter(function (hyp) {
        return hyp.typ === "E";
      });
  var frmConstPartsArr = [];
  var constPartsArr = [];
  var varGroupsArr = [];
  hypsE.forEach(function (hyp) {
        var frmConstParts = createConstParts(hyp.expr);
        var constParts = createMatchingConstParts(frmConstParts);
        var varGroups = createVarGroups(hyp.expr, frmConstParts);
        frmConstPartsArr.push(frmConstParts);
        constPartsArr.push(constParts);
        varGroupsArr.push(varGroups);
      });
  var frmConstParts = createConstParts(frame.asrt);
  var constParts = createMatchingConstParts(frmConstParts);
  var varGroups = createVarGroups(frame.asrt, frmConstParts);
  frmConstPartsArr.push(frmConstParts);
  constPartsArr.push(constParts);
  varGroupsArr.push(varGroups);
  var subs = createSubs(frame.numOfVars);
  return {
          frame: frame,
          hypsE: hypsE,
          numOfHypsE: hypsE.length,
          frmConstParts: frmConstPartsArr,
          constParts: constPartsArr,
          varGroups: varGroupsArr,
          subs: subs
        };
}

function prepareFrmSubsData(ctx) {
  var frmCmp = Expln_utils_common.comparatorAndThen(Expln_utils_common.comparatorByInt(function (frm) {
            return frm.hypsE.length;
          }), Expln_utils_common.comparatorByInt(function (frm) {
            return frm.frame.ord;
          }));
  var all = Expln_utils_common.sortInPlaceWith(MM_context.getAllFramesArr(ctx).map(prepareFrmSubsDataForFrame), frmCmp);
  var byLabel = Belt_HashMapString.make(1000);
  var byType = Belt_HashMapInt.make(16);
  all.forEach(function (frm) {
        Belt_HashMapString.set(byLabel, frm.frame.label, frm);
        var typ = frm.frame.asrt[0];
        var arr = Belt_HashMapInt.get(byType, typ);
        if (arr !== undefined) {
          arr.push(frm);
          return ;
        } else {
          return Belt_HashMapInt.set(byType, typ, [frm]);
        }
      });
  return {
          all: all,
          byType: byType,
          byLabel: byLabel
        };
}

function sortFrames(frms, frames) {
  var framesSet = Belt_HashSetString.fromArray(frames);
  return frms.all.filter(function (frm) {
                return Belt_HashSetString.has(framesSet, frm.frame.label);
              }).map(function (frm) {
              return frm.frame.label;
            });
}

function applySubs(frmExpr, subs, createWorkVar) {
  var resultSize = {
    contents: 0
  };
  frmExpr.forEach(function (s) {
        if (s < 0 || !subs.isDefined[s]) {
          resultSize.contents = resultSize.contents + 1 | 0;
        } else {
          resultSize.contents = resultSize.contents + ((subs.ends[s] - subs.begins[s] | 0) + 1 | 0) | 0;
        }
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = frmExpr[e];
    if (s < 0) {
      res[r] = s;
      r = r + 1 | 0;
    } else if (subs.isDefined[s]) {
      var subExpr = subs.exprs[s];
      var len = (subs.ends[s] - subs.begins[s] | 0) + 1 | 0;
      Expln_utils_common.copySubArray(subExpr, subs.begins[s], res, r, len);
      r = r + len | 0;
    } else {
      res[r] = createWorkVar(s);
      r = r + 1 | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function verifyDisjoints(frmDisj, subs, isDisjInCtx, debugLevel) {
  var res = {
    contents: undefined
  };
  Belt_MapInt.forEach(frmDisj, (function (n, ms) {
          if (Belt_Option.isNone(res.contents)) {
            return Belt_SetInt.forEach(ms, (function (m) {
                          if (!Belt_Option.isNone(res.contents)) {
                            return ;
                          }
                          var nExpr = subs.exprs[n];
                          var nExprBegin = subs.begins[n];
                          var nExprEnd = subs.ends[n];
                          var mExpr = subs.exprs[m];
                          var mExprBegin = subs.begins[m];
                          var mExprEnd = subs.ends[m];
                          for(var nExprI = nExprBegin; nExprI <= nExprEnd; ++nExprI){
                            if (Belt_Option.isNone(res.contents)) {
                              var nExprSym = nExpr[nExprI];
                              if (nExprSym >= 0) {
                                for(var mExprI = mExprBegin; mExprI <= mExprEnd; ++mExprI){
                                  if (Belt_Option.isNone(res.contents)) {
                                    var mExprSym = mExpr[mExprI];
                                    if (mExprSym >= 0) {
                                      if (nExprSym === mExprSym) {
                                        if (debugLevel === 0) {
                                          res.contents = "UnifErr";
                                        } else {
                                          res.contents = {
                                            TAG: "DisjCommonVar",
                                            frmVar1: n,
                                            expr1: nExpr.slice(nExprBegin, nExprEnd + 1 | 0),
                                            frmVar2: m,
                                            expr2: mExpr.slice(mExprBegin, mExprEnd + 1 | 0),
                                            commonVar: nExprSym
                                          };
                                        }
                                      } else if (!isDisjInCtx(nExprSym, mExprSym)) {
                                        if (debugLevel === 0) {
                                          res.contents = "UnifErr";
                                        } else {
                                          res.contents = {
                                            TAG: "Disj",
                                            frmVar1: n,
                                            expr1: nExpr.slice(nExprBegin, nExprEnd + 1 | 0),
                                            var1: nExprSym,
                                            frmVar2: m,
                                            expr2: mExpr.slice(mExprBegin, mExprEnd + 1 | 0),
                                            var2: mExprSym
                                          };
                                        }
                                      }
                                      
                                    }
                                    
                                  }
                                  
                                }
                              }
                              
                            }
                            
                          }
                        }));
          }
          
        }));
  return res.contents;
}

function frmsEmpty() {
  return {
          all: [],
          byType: Belt_HashMapInt.make(0),
          byLabel: Belt_HashMapString.make(0)
        };
}

function frmsSize(frms) {
  return frms.all.length;
}

function frmsForEach(frms, typ, consumer) {
  if (typ !== undefined) {
    return Belt_Option.forEach(Belt_HashMapInt.get(frms.byType, typ), (function (__x) {
                  __x.forEach(consumer);
                }));
  } else {
    frms.all.forEach(consumer);
    return ;
  }
}

function frmsSelect(frms, typ, label) {
  if (typ !== undefined) {
    if (label !== undefined) {
      var frm = Belt_Option.keep(Belt_HashMapString.get(frms.byLabel, label), (function (frm) {
              return frm.frame.asrt[0] === typ;
            }));
      if (frm !== undefined) {
        return [frm];
      } else {
        return [];
      }
    }
    var arr = Belt_HashMapInt.get(frms.byType, typ);
    if (arr !== undefined) {
      return arr.slice();
    } else {
      return [];
    }
  }
  if (label === undefined) {
    return frms.all.slice();
  }
  var frm$1 = Belt_HashMapString.get(frms.byLabel, label);
  if (frm$1 !== undefined) {
    return [frm$1];
  } else {
    return [];
  }
}

function frmsGetAll(frms) {
  return frms.all;
}

function frmsGetByLabel(frms, label) {
  return Belt_HashMapString.get(frms.byLabel, label);
}

function frmsGetByType(frms, typ) {
  return Belt_HashMapInt.get(frms.byType, typ);
}

function frmsGetAllTypes(frms) {
  return Belt_HashMapInt.keysToArray(frms.byType);
}

function frmsGetAllGroupedByLabel(frms) {
  return frms.byLabel;
}

function test_iterateConstParts(frmExpr, expr, parenCnt) {
  var constPartsToArr = function (constParts) {
    return constParts.begins.map(function (b, i) {
                return [
                        b,
                        constParts.ends[i]
                      ];
              });
  };
  var frmConstParts = createConstParts(frmExpr);
  var constParts = createMatchingConstParts(frmConstParts);
  var matchingConstParts = [];
  iterateConstParts(frmExpr, expr, frmConstParts, constParts, 0, parenCnt, (function (constParts) {
          matchingConstParts.push(constPartsToArr(constParts));
          return "Continue";
        }));
  return [
          constPartsToArr(frmConstParts),
          matchingConstParts
        ];
}

function test_iterateSubstitutions(frmExpr, expr, parenCnt) {
  var frmConstParts = createConstParts(frmExpr);
  var constParts = createMatchingConstParts(frmConstParts);
  var varGroups = createVarGroups(frmExpr, frmConstParts);
  var numOfVars = Belt_SetInt.size(Belt_SetInt.fromArray(frmExpr.filter(function (i) {
                return i >= 0;
              })));
  var subs = createSubs(numOfVars);
  var result = [];
  iterateSubstitutions(frmExpr, expr, frmConstParts, constParts, varGroups, subs, parenCnt, (function (subs) {
          var res = [];
          for(var i = 0; i < numOfVars; ++i){
            res.push(subs.exprs[i].slice(subs.begins[i], subs.ends[i] + 1 | 0));
          }
          result.push(res);
          return "Continue";
        }));
  return result;
}

exports.subsClone = subsClone;
exports.subsEq = subsEq;
exports.subsHash = subsHash;
exports.createConstParts = createConstParts;
exports.createMatchingConstParts = createMatchingConstParts;
exports.createSubs = createSubs;
exports.prepareFrmSubsDataForFrame = prepareFrmSubsDataForFrame;
exports.prepareFrmSubsData = prepareFrmSubsData;
exports.sortFrames = sortFrames;
exports.iterateSubstitutions = iterateSubstitutions;
exports.applySubs = applySubs;
exports.verifyDisjoints = verifyDisjoints;
exports.frmsEmpty = frmsEmpty;
exports.frmsSize = frmsSize;
exports.frmsForEach = frmsForEach;
exports.frmsGetAll = frmsGetAll;
exports.frmsGetByLabel = frmsGetByLabel;
exports.frmsGetByType = frmsGetByType;
exports.frmsSelect = frmsSelect;
exports.frmsGetAllTypes = frmsGetAllTypes;
exports.frmsGetAllGroupedByLabel = frmsGetAllGroupedByLabel;
exports.test_iterateConstParts = test_iterateConstParts;
exports.test_iterateSubstitutions = test_iterateSubstitutions;
/* MM_context Not a pure module */
